import {Header, Footer} from './components';
import './App.css';

function App() {
  return (
    <>
      <Header />
      <Footer />
    </>
  );
}

export default App;
